import React from 'react'
import styled from 'styled-components'

export enum RenditionType {
    Small = 'downsized',
    Social = 'downsized_large',
    Original = 'source',
}

const TrayContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 270px;
    justify-content: space-between;
    margin: auto;
    margin-top: 40px;
`

const RenditionSelector = styled.span<{ selected: boolean }>`
    font-size: 13px;
    cursor: pointer;
    opacity: 0.6;

    ${({ selected }) =>
        selected &&
        `
        opacity: 1.0;
        border-bottom: solid .8px white;
    `}

    span {
        font-weight: bold;
    }
`
type Props = {
    currentRendition: RenditionType
    setRenditionType: (whichRendition: RenditionType) => void
}

export const RenditionTray = ({ currentRendition, setRenditionType }: Props) => {
    return (
        <TrayContainer>
            <RenditionSelector
                onClick={() => setRenditionType(RenditionType.Small)}
                selected={currentRendition === RenditionType.Small}
            >
                <span>Small</span> &lt;2mb
            </RenditionSelector>
            <RenditionSelector
                onClick={() => setRenditionType(RenditionType.Social)}
                selected={currentRendition === RenditionType.Social}
            >
                <span>Social</span> &lt;10mb
            </RenditionSelector>
            <RenditionSelector
                onClick={() => setRenditionType(RenditionType.Original)}
                selected={currentRendition === RenditionType.Original}
            >
                <span>Original</span> &lt;15mb
            </RenditionSelector>
        </TrayContainer>
    )
}
